import React from "react";
import { calcMag } from "../utils/math3d";

export const Lights = ({ intensity, castShadow, position, preset}) => {
    const config = presets[preset];
    const pointLightPosition = [config.fill[0], config.fill[1], config.fill[2]];
    const shadowBias = -0.000001;
    const normalBias = 0.001;
    const shadowSize = 2048;
    const originalPositionLength = calcMag(position);
    // Set spotlight distance to always be 2
    const spotLightPosition = position.map(x => x / originalPositionLength * 2);
    return (
        <>
          <ambientLight intensity={intensity / 3} />
          <spotLight
              castShadow={castShadow}
              penumbra={1}
              position={spotLightPosition}
              intensity={intensity}
              distance={10}
              shadow-bias={shadowBias}
              shadow-camera-near={0.001}
              shadow-camera-far={15}
              shadow-normalBias={normalBias}
              shadow-mapSize={shadowSize}
              decay={0}
          />
          <pointLight
              position={pointLightPosition}
              intensity={intensity}
              castShadow={false}
              decay={0}
          />
        </>
    );
};

const presets = {
    rembrandt: {
        main: [1, 2, 1],
        fill: [-2, -0.5, -2],
    },
    portrait: {
        main: [-1, 2, 0.5],
        fill: [-1, 0.5, -1.5],
    },
    upfront: {
        main: [0, 2, 1],
        fill: [-1, 0.5, -1.5],
    },
    soft: {
        main: [-2, 4, 4],
        fill: [-1, 0.5, -1.5],
    },
};
